import { createUrl } from "../create-url";
import { TCustomerPortalRoutes, TRoute, TRoutes } from "../routes.types";

export const customerPortal: TCustomerPortalRoutes = {
  auth: {
    index: ({ config }: TRoute = {}) =>
      createUrl("/", config),
    account: {
      settings: ({ config }: TRoute = {}) =>
        createUrl("/account/settings", config),
      billing: ({ config }: TRoute = {}) =>
        createUrl("/account/billing", config),
      managePassword: ({ config }: TRoute = {}) =>
        createUrl("/account/manage-password", config),
    },
    community: {
      index: ({ config }: TRoute = {}) =>
        createUrl("/community", config),
      referAFriend:({ config }: TRoute = {}) =>
        createUrl("/community/refer-a-friend", config),
    },
    rewards: {
      index: ({ config }: TRoute = {}) =>
        createUrl("/rewards", config),
    },
    cats: {
      index: ({ config }: TRoute = {}) =>
        createUrl("/cats", config),
    },
    plans: {
      index: ({ config }: TRoute = {}) =>
        createUrl("/plans", config),
    },
    orders: {
      receipts: ({ config }: TRoute = {}) =>
        createUrl("/orders/receipts", config),
    },
  },
  guest: {
    login: ({
      config,
    }: TRoute<undefined, { redirect?: string | null }> = {}) =>
      createUrl("/login", config),
    recoverPassword: ({ config }: TRoute = {}) =>
      createUrl("/recover-password", config),
  },
} as const satisfies TRoutes;
